














































import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUsers, faFlag, faFingerprint } from '@fortawesome/free-solid-svg-icons';
import moment, { Moment } from 'moment';

import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Activity } from '@activities/interfaces/activity';
library.add(faUsers, faFlag, faFingerprint);

@Component({
  name: 'bpc-competition-card',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class CompetitionCard extends Vue {
  @Prop({ type: Object }) readonly activity: Activity;
  @Prop({ type: Boolean, default: false }) readonly hideCardShadow: boolean;

  // DATA
  // LIFECYCLE
  // METHODS
  onEdit() {
    this.$emit('edit', this.activity);
  }

  onShow() {
    this.$emit('show', this.activity);
  }

  onDelete() {
    this.$emit('delete', this.activity.id);
  }

  // COMPUTED
  get shortDescription(): string {
    const clamp = '...';
    const length = 80;
    if (this.activity.short_description) {
      return this.activity.short_description.length > length
        ? this.activity.short_description.slice(0, length) + clamp
        : this.activity.short_description;
    }

    return null;
  }

  get teamName(): string {
    return this.activity?.team?.fullname;
  }

  get coachName(): string {
    return this.activity?.contact?.fullname;
  }

  get startDate(): string {
    if (this.activity.start_date) {
      return moment(this.activity.start_date, 'YYYY-MM-DD')
        .locale('fr')
        .format('DD/MM/YYYY');
    }
    return null;
  }

  get endDate(): string {
    if (this.activity.end_date) {
      return moment(this.activity.end_date, 'YYYY-MM-DD')
        .locale('fr')
        .format('DD/MM/YYYY');
    }
    return null;
  }

  get dateRange(): string {
    if (this.startDate && this.endDate && this.startDate !== this.endDate) {
      return `${this.startDate} - ${this.endDate}`;
    } else if (this.startDate) {
      return this.startDate;
    } else if (this.endDate) {
      return this.endDate;
    } else {
      return null;
    }
  }

  get ageRange(): string {
    if (this.activity.min_age && this.activity.max_age) {
      return `${this.activity.min_age} - ${this.activity.max_age}` + this.$t('global.years_old');
    } else if (this.activity.min_age) {
      return this.$t('global_from_age', { age: this.activity.min_age }) as string;
    } else if (this.activity.max_age) {
      return this.$t('global.to_age', { age: this.activity.max_age }) as string;
    } else {
      return this.$t('global.all_ages') as string;
    }
  }

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  get imgUrl() {
    if (this.imgFail) {
      if (this.$store.getters['centerSettings/backgroundUrl']) {
        return this.$store.getters['centerSettings/backgroundUrl'];
      } else if (this.$store.getters['centerSettings/logoUrl']) {
        return this.$store.getters['centerSettings/logoUrl'];
      }
      return null;
    }

    return this.activity.activities[this.currentImgField];
  }
  // WATCHERS
}
